import React, { Component } from 'react';
import { getAllLists } from './services/items';

/* material ui*/
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import axios from 'axios';
import { BASE_API } from '../../Shared/Constants';
import { getTokenCredentials } from '../../Shared/functions';
import ClipLoader from 'react-spinners/ClipLoader';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
  } from 'chart.js';
import { Bar} from 'react-chartjs-2';
import { getAllPenalities } from '../penalities/services/penalities';
import { getPaymentList } from '../treasury/services/services';


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
  );

class Items extends Component {

   constructor(props) {
    super(props);
    this.state = {
      users:0,
      officials:0,
      penalities:0,
      payedPenalities:0,
      allPenalities:[],
      totals: {},
      totalValues:null,
      data: [],
      dataCategory: [],
      currentCategory: 0,

        desde: this.getLocalDateString(),
        hasta: this.getLocalDateString(),

        // Indica si ya se filtró por fecha (clic en "Buscar"). appliedDesde/Hasta
        // son el snapshot de las fechas usadas en esa búsqueda, para que el
        // recuadro coincida con los datos mostrados aunque cambien los inputs.
        dateFiltered: false,
        appliedDesde: '',
        appliedHasta: '',

      // desde: new Date().toISOString().split('T')[0],
      // hasta: new Date().toISOString().split('T')[0],
      loading: false,
      labels: null,
      items: null,
      options: null,
      showChart: false,
      itemsChart:null,
      totalPenalitiesToday:0,
      totalPenalitiesPayedToday:0,
      totalPayedCostToday:0,
      payedPayedCostToday:0,
      partialPayedPayedCostToday:0,
    };
  }

  stats = [
      { name: 'Ayer', value: 0, change: 'Multas impuestas', changeType: 'positive', category: 0 },
      { name: 'Hoy', value: 0, change: 'Multas impuestas', changeType: 'positive', category: 1 },
      { name: 'Semanal', value: 0, change: 'Multas impuestas', changeType: 'positive', category: 2 },
      { name: 'Quincenal', value: 0, change: 'Multas impuestas', changeType: 'positive', category: 3 },
      { name: 'Mensual', value: 0, change: 'Multas impuestas', changeType: 'positive', category: 4 },
      { name: 'Trimestral', value: 0, change: 'Multas impuestas', changeType: 'positive', category: 5},
      { name: 'Semestral', value: 0, change: 'Multas impuestas', changeType: 'positive', category: 6 },
      { name: 'Anual', value: 0, change: 'Multas impuestas', changeType: 'positive', category: 7 },
  ]

  getLocalDateString = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  componentDidMount = () => {
    this.loadAllData();
  }

  loadAllData = async () => {
    this.setState({ loading: true });
    
    try {
      // Cargar todos los datos en paralelo
      const [listsResult, currentDataResult, paymentsResult, todayCostResult] = await Promise.all([
        this.loadListsData(),
        this.loadCurrentData(),
        this.loadCurrentDataPayments(),
        this.loadTotalPayedCostToday()
      ]);

      // Actualizar el estado con todos los datos al final
      this.setState({
        loading: false,
        ...listsResult,
        ...currentDataResult,
        ...paymentsResult,
        ...todayCostResult
      });
    } catch (error) {
      console.log("Error loading data:", error);
      this.setState({ loading: false });
    }
  }

  loadListsData = () => {
    return getAllLists({}).then((result) => {
      if(result !== null && result.data) {
        let yesterday = 0;
        let today = 0;
        let week = 0;
        let fortnightly = 0;
        let monthly = 0;
        let quarterly = 0;
        let biannual = 0;
        let year = 0;
        
        result.data.data.forEach(element => {
          if(element.idCategory === 0) {
            yesterday += element.total;
          }
          if(element.idCategory === 1) {
            today += element.total;
          }
          if(element.idCategory === 2) {
            week += element.total;
          }
          if(element.idCategory === 3) {
            fortnightly += element.total;
          }
          if(element.idCategory === 4) {
            monthly += element.total;
          }
          if(element.idCategory === 5) {
            quarterly += element.total;
          } 
          if(element.idCategory === 6) {
            biannual += element.total;
          }
          if(element.idCategory === 7) {
            year += element.total;
          }
        });
        
        return {
          dataCategory: result.data.data,
          totals: {yesterday, today, week, fortnightly, monthly, quarterly, biannual, year}
        };
      } else {
        return {
          dataCategory: [],
          totals: {yesterday:0, today:0, week:0, fortnightly:0, monthly:0, quarterly:0, biannual:0, year:0}
        };
      }
    }).catch((error) => {
      console.log("Error loading lists:", error);
      return {
        dataCategory: [],
        totals: {yesterday:0, today:0, week:0, fortnightly:0, monthly:0, quarterly:0, biannual:0, year:0}
      };
    });
  }



  renderIcon = () =>{
    return(
        <div className="pl-1 pr-1">
            <svg style={{color:'#001a61'}} 
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
            </svg>
        </div>
    )
  }

  classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

  generateColors(count) {
    const colors = [];
    for (let i = 0; i < count; i++) {
      const r = Math.floor(Math.random() * 100) + 100;
      const g = Math.floor(Math.random() * 100) + 100;
      const b = Math.floor(Math.random() * 100) + 100;
      colors.push(`rgb(${r}, ${g}, ${b})`);
    }
    return colors;
  }

  returnByCategory = (category) => {
    if(this.state.dataCategory.length > 0) {
        const items = this.state.dataCategory.filter((item) => item.idCategory === category);
        return(
            <div className="space-y-1">
                {items.map((item) => (
                    <div key={item.descripStatus} className="flex flex-row justify-between">
                        <p className="font-semibold text-gray-600" style={{fontSize:12}}>{item.descripStatus}:</p>
                        <p className="text-gray-700">{item.total?.toLocaleString('es-ES', {
    useGrouping: true,
  }) ?? 0}</p>
                    </div>
                ))}
            </div>
        )
    }else{
        return(
            <div className="flex flex-row justify-between">
                <p className="font-semibold text-gray-500">Sin datos</p>
            </div>
        )
  }
}

  getTotalByStat = (category) => {
    if(category === 0) {
        return (
            <div className="flex flex-row items-baseline gap-2">
                <p className="text-sm font-bold">{this.state.totals.yesterday?.toLocaleString('es-ES', {
                    useGrouping: true,
                }) ?? 0}</p>
                <p className="text-sm text-gray-500">Total</p>
            </div>
        )
    }
    if(category === 1) {
        return (
            <div className="flex flex-row items-baseline gap-2">
                <p className="text-sm font-bold">{this.state.totals.today?.toLocaleString('es-VE', {
    useGrouping: true,
  }) ?? 0}</p>
                <p className="text-sm text-gray-500">Total</p>
            </div>
        )
    }
    if(category === 2) {
        return (
            <div className="flex flex-row items-baseline gap-2">
                <p className="text-sm font-bold">{this.state.totals.week?.toLocaleString('es-VE', {
    useGrouping: true,
  }) ?? 0}</p>
                <p className="text-sm text-gray-500">Total</p>
            </div>
        )
    }
    if(category === 3) {
        return (
            <div className="flex flex-row items-baseline gap-2">
                <p className="text-sm font-bold">{this.state.totals.fortnightly?.toLocaleString('es-VE', {
    useGrouping: true,
  }) ?? 0}</p>
                <p className="text-sm text-gray-500">Total</p>
            </div>
        )
    }
    if(category === 4) {
        return (
            <div className="flex flex-row items-baseline gap-2">
                <p className="text-sm font-bold">{this.state.totals.monthly?.toLocaleString('es-VE', {
    useGrouping: true,
  }) ?? 0}</p>
                <p className="text-sm text-gray-500">Total</p>
            </div>
        )
    }
    if(category === 5) {
        return (
            <div className="flex flex-row items-baseline gap-2">
                <p className="text-sm font-bold">{this.state.totals.quarterly?.toLocaleString('es-VE', {
    useGrouping: true,
  }) ?? 0}</p>
                <p className="text-sm text-gray-500">Total</p>
            </div>
        )
    }
    if(category === 6) {
        return (
            <div className="flex flex-row items-baseline gap-2">
                <p className="text-sm font-bold">{this.state.totals.biannual?.toLocaleString('es-VE', {
    useGrouping: true,
  }) ?? 0}</p>
                <p className="text-sm text-gray-500">Total</p>
            </div>
        )
    }
    if(category === 7) {
        
        return (
            <div className="flex flex-row items-baseline gap-2">
                <p className="text-sm font-bold">{this.state.totals.year?.toLocaleString('es-VE', {
    useGrouping: true,
  }) ?? 0}</p>
                <p className="text-sm text-gray-500">Total</p>
            </div>
        )
    }
  }

  formatDateOnly = (value) => {
    return value
  }

  // "AAAA-MM-DD" -> "DD/MM/AAAA". Se parte el string en vez de usar new Date()
  // para evitar corrimientos de día por zona horaria.
  formatDisplayDate = (value) => {
    if(!value) return '';
    const [year, month, day] = value.split('-');
    if(!year || !month || !day) return value;
    return `${day}/${month}/${year}`;
  }

  search = async () => {  
    const url = 'api/statistics/bystatus';
    if(this.state.desde === '' || this.state.hasta === '') {
        alert('Por favor seleccione las fechas para filtrar');
        return;
    }
    
    this.setState({loading: true});
    
    try {
      const dateStart = new Date(this.state.desde + 'T00:00:00');
      const dateEnd = new Date(this.state.hasta + 'T23:59:59');
      
      const response = await axios.post(BASE_API + url, {
          dateStart: dateStart.toISOString(),
          dateEnd: dateEnd.toISOString(),
          idStatus: -1
      }, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Basic ' + getTokenCredentials()
          }
      });
      
      if(!response || !response.data || !response.data.data) {
        alert('Error: No se recibieron datos válidos');
        this.setState({loading: false});
        return;
      }
      
      const data = response.data.data;
      if(!Array.isArray(data)) {
        alert('Error: Los datos recibidos no son válidos');
        this.setState({loading: false});
        return;
      }
      
      const labels = data.map((item) => item.status + ' Total: ' + item.total);
      const items = data.map((item) => item.percentage);

      const payed = data.filter((item) => item.idStatus === 3);
      const partialPayed = data.filter((item) => item.idStatus === 5);
      
      this.setState({
        totalValues: {payed: payed[0], partialPayed: partialPayed[0]},
        showChart: true,
        labels: labels,
        items: items,
        data: data,
        loading: false,
        dateFiltered: true,
        appliedDesde: this.state.desde,
        appliedHasta: this.state.hasta
      });
    } catch (error) {
        console.log("Error in search:", error);
        alert(error.response?.data?.message || 'Error consultando estadísticas');
        this.setState({loading: false});
    }
  }

  loadCurrentData = () => {
    const url = 'api/statistics/bystatus';
    if(this.state.desde === '' || this.state.hasta === '') {
        return Promise.resolve({});
    }
    
    const dateEnd = new Date(this.state.hasta + 'T23:59:59');
    
    return axios.post(BASE_API + url, {
        dateStart: '2025-01-01T01:00:00.000Z',
        dateEnd: dateEnd.toISOString(),
        idStatus: -1
    }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + getTokenCredentials()
        }
    })
    .then(response => { 
        if(!response || !response.data || !response.data.data) {
            return {};
        }
        
        const data = response.data.data;
        if(!Array.isArray(data)) {
            return {};
        }
        
        const labels = data.map((item) => item.status + ' Total: ' + item.total);
        const items = data.map((item) => item.percentage);

        const payed = data.filter((item) => item.idStatus === 3);
        const partialPayed = data.filter((item) => item.idStatus === 5);
        
        return {
            totalValues: {payed: payed[0], partialPayed: partialPayed[0]},
            showChart: true,
            labels: labels,
            items: items,
            data: data
        };
    }).catch((error) => {
        console.log("Error in loadCurrentData:", error);
        return {};
    });
  }

  loadTotalPayedCostToday = () => {
    const url = 'api/statistics/bystatus';
    if(this.state.desde === '' || this.state.hasta === '') {
        return Promise.resolve({});
    }
    
    const today = this.getLocalDateString();
    const dateStart = new Date(today + 'T00:00:00');
    const dateEnd = new Date(today + 'T23:59:59');
    
    return axios.post(BASE_API + url, {
        dateStart: dateStart.toISOString(),
        dateEnd: dateEnd.toISOString(),
        idStatus: -1
    }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + getTokenCredentials()
        }
    })
    .then(response => { 
        if(!response || !response.data || !response.data.data) {
            return {};
        }
        
        const data = response.data.data;
        if(!Array.isArray(data)) {
            return {};
        }
        
        const payed = data.filter((item) => item.idStatus === 3);
        const partialPayed = data.filter((item) => item.idStatus === 5);
        return {
            payedPayedCostToday: payed[0],
            partialPayedPayedCostToday: partialPayed[0]
        };
    }).catch((error) => {
        console.log("Error in loadTotalPayedCostToday:", error);
        return {};
    });
  }

  loadCurrentDataPayments = () => {
    const today = this.getLocalDateString();
    const dateStart = new Date(today + 'T00:00:00');
    const dateEnd = new Date(today + 'T23:59:59');
    
    const penalitiesPromise = getAllPenalities({
      dateStart: dateStart.toISOString(),
      dateEnd: dateEnd.toISOString(),
      idStatus: -1,
      limit: 0,
    }).then(response => { 
      let totalPenalitiesToday = 0;
      if(response && response.data && response.data.data) {
        const data = response.data.data;
        if(Array.isArray(data)) {
          data.forEach(item => {
            if(item.headerFine) {
              totalPenalitiesToday += item.headerFine.length;
            } 
          });
        }
      }
      return { totalPenalitiesToday };
    }).catch((error) => {
      console.log("Error in penalities:", error);
      return { totalPenalitiesToday: 0 };
    });

    const paymentsPromise = getPaymentList({
      dateStart: dateStart.toISOString(),
      dateEnd: dateEnd.toISOString(),
      limit: 0,
    }).then(response => {
      let total = 0;
      if(response && response.data && response.data.data && response.data.data.data) {
        total = Array.isArray(response.data.data.data) ? response.data.data.data.length : 0;
      }
      return { totalPenalitiesPayedToday: total };
    }).catch((error) => {
      console.log("Error in payments:", error);
      return { totalPenalitiesPayedToday: 0 };
    });

    return Promise.all([penalitiesPromise, paymentsPromise]).then(([penalitiesResult, paymentsResult]) => {
      return {
        ...penalitiesResult,
        ...paymentsResult
      };
    }).catch((error) => {
      console.log("Error in Promise.all:", error);
      return {
        totalPenalitiesToday: 0,
        totalPenalitiesPayedToday: 0
      };
    });
  }

  formatNumber = (number) => {
    if(number === null || number === undefined) return '0,00';
    const num = Number(number);
    if (isNaN(num)) return '0,00';
    return num.toLocaleString('es-ES', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true
    });
  }

  // Tarjeta "Total Pagadas". Se muestra en el grid normalmente; cuando hay
  // filtro de fecha aplicado (dateFiltered) se renderiza al tope, sobre "Resumen Hoy".
  renderTotalPagadasCard = () => {
    return (
      <div
        key={'Total pagadas'}
        className={`relative overflow-hidden rounded-2xl p-6 shadow-lg ring-1 ${this.state.dateFiltered ? 'bg-gradient-to-br from-green-50 to-emerald-100 ring-green-300/60' : 'bg-gradient-to-br from-gray-50 to-slate-100 ring-gray-200/50'}`}
      >
        <div className="relative">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-3">
              <div className={`flex h-12 w-12 items-center justify-center rounded-xl shadow-lg ${this.state.dateFiltered ? 'bg-gradient-to-br from-green-600 to-emerald-700' : 'bg-gradient-to-br from-gray-600 to-slate-700'}`}>
                <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <dt className="text-lg font-semibold text-gray-800">Total Pagadas</dt>
                {this.state.dateFiltered && (
                  <p className="text-sm font-medium text-green-700">
                    {this.formatDisplayDate(this.state.appliedDesde)} — {this.formatDisplayDate(this.state.appliedHasta)}
                  </p>
                )}
              </div>
            </div>
          </div>
          <dd className="space-y-3">
            <div className="flex items-center justify-between rounded-lg bg-white/60 p-3">
              <span className="text-sm font-medium text-gray-600">Bolívares</span>
              <span className="text-sm font-bold text-gray-900">Bs. {this.formatNumber(this.state.totalValues?.payed?.totalXStatus?.amount)}</span>
            </div>
            <div className="flex items-center justify-between rounded-lg bg-white/60 p-3">
              <span className="text-sm font-medium text-gray-600">Dólares</span>
              <span className="text-sm font-bold text-gray-900">$ {this.formatNumber(this.state.totalValues?.payed?.totalXStatus?.amountDolar)}</span>
            </div>
            <div className="flex items-center justify-between rounded-lg bg-white/60 p-3">
              <span className="text-sm font-medium text-gray-600">Euros</span>
              <span className="text-sm font-bold text-gray-900">€ {this.formatNumber(this.state.totalValues?.payed?.totalXStatus?.amountEur)}</span>
            </div>
          </dd>
        </div>
      </div>
    )
  }

  render() {
    return (
    <div className="max-w-7xl mx-auto px-4">  
        {
            this.state.loading ? 
            <center className="py-8">
                <ClipLoader/>
            </center> : null
        }   
        <div className="py-6 relative">
            <header>
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                    <div>
                      <h2 className="text-3xl font-bold tracking-tight text-gray-900">
                          Sistema Administrativo
                      </h2>
                      <p className="text-sm text-gray-500">Panel de resumen y estadísticas</p>
                    </div>
                    <div className="flex flex-row flex-wrap gap-3 items-end bg-white/60 rounded-md p-3 ring-1 ring-gray-200">
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700">Desde</label>
                            <input 
                                type="date" 
                                className="border rounded px-2 py-1 text-sm"
                                value={this.state.desde}
                                onChange={(e) => {this.setState({desde:e.target.value})}} />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700">Hasta</label>
                            <input 
                                type="date" 
                                className="border rounded px-2 py-1 text-sm"
                                value={this.state.hasta}
                                onChange={(e) => {this.setState({hasta: e.target.value})}} />
                        </div>
                        <button 
                            onClick={() => {this.search()}}
                            className="bg-blue-950 hover:bg-blue-950 text-white font-semibold py-2 px-4 rounded text-sm"
                        >
                          Buscar
                        </button>
                    </div>
                </div>
            </header>
        </div>
        {/* Total Pagadas filtrado: sube al tope, sobre "Resumen Hoy" */}
        {this.state.dateFiltered && (
            <div className="mb-6">
                {this.renderTotalPagadasCard()}
            </div>
        )}
    {/* Tarjeta Totales Hoy */}
        <div
            key={'Totales hoy'}
            className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-gray-50 to-slate-100 p-6 shadow-lg ring-1 ring-gray-200/50 sm:col-span-2 lg:col-span-1"
          >
            <div className="relative">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-3">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-gray-600 to-slate-700 shadow-lg">
                    <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                    </svg>
                  </div>
                  <div>
                    <dt className="text-lg font-semibold text-gray-800">Resumen Hoy</dt>
                    <p className="text-sm text-gray-600">Actividad del día</p>
                  </div>
                </div>
              </div>
              <dd className="space-y-3">
                <div className="grid grid-cols-2 gap-3 mb-3">
                  <div className="flex items-center justify-between rounded-lg bg-white/60 p-3">
                    <span className="text-sm font-medium text-gray-600">Multas impuestas</span>
                    <span className="text-sm font-bold text-gray-900">{this.state.totalPenalitiesToday}</span>
                  </div>
                  <div className="flex items-center justify-between rounded-lg bg-white/60 p-3">
                    <span className="text-sm font-medium text-gray-600">Multas pagadas</span>
                    <span className="text-sm font-bold text-gray-900">{this.state.totalPenalitiesPayedToday}</span>
                  </div>
                </div>
                
                <div className="grid grid-cols-2 gap-3">
                  <div className="space-y-3">
                    <div className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Pagos Completos</div>
                    <div className="rounded-lg bg-white/60 p-3">
                      <div className="text-sm font-medium text-gray-600 mb-1">Monto Bs.</div>
                      <div className="text-sm font-bold text-gray-900">Bs. {this.formatNumber(this.state.payedPayedCostToday?.totalXStatus?.amount)}</div>
                    </div>
                    <div className="rounded-lg bg-white/60 p-3">
                      <div className="text-sm font-medium text-gray-600 mb-1">Monto $</div>
                      <div className="text-sm font-bold text-gray-900">${this.formatNumber(this.state.payedPayedCostToday?.totalXStatus?.amountDolar)}</div>
                    </div>
                    <div className="rounded-lg bg-white/60 p-3">
                      <div className="text-sm font-medium text-gray-600 mb-1">Monto €</div>
                      <div className="text-sm font-bold text-gray-900">€ {this.formatNumber(this.state.payedPayedCostToday?.totalXStatus?.amountEur)}</div>
                    </div>
                  </div>
                  
                  <div className="space-y-3">
                    <div className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Pagos Parciales</div>
                    <div className="rounded-lg bg-white/60 p-3">
                      <div className="text-sm font-medium text-gray-600 mb-1">Monto Bs.</div>
                      <div className="text-sm font-bold text-gray-900">Bs. {this.formatNumber(this.state.partialPayedPayedCostToday?.totalXStatus?.amount)}</div>
                    </div>
                    <div className="rounded-lg bg-white/60 p-3">
                      <div className="text-sm font-medium text-gray-600 mb-1">Monto $</div>
                      <div className="text-sm font-bold text-gray-900">${this.formatNumber(this.state.partialPayedPayedCostToday?.totalXStatus?.amountDolar)}</div>
                    </div>
                    <div className="rounded-lg bg-white/60 p-3">
                      <div className="text-sm font-medium text-gray-600 mb-1">Monto €</div>
                      <div className="text-sm font-bold text-gray-900">€ {this.formatNumber(this.state.partialPayedPayedCostToday?.totalXStatus?.amountEur)}</div>
                    </div>
                  </div>
                </div>
              </dd>
            </div>
          </div>
        <dl className="mx-auto grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-2" style={{marginTop:'20px'}}>
          {/* Tarjeta Total Pagadas (cuando está filtrada sube al tope, así que aquí solo se muestra sin filtro) */}
          {!this.state.dateFiltered && this.renderTotalPagadasCard()}

          {/* Tarjeta Total Parciales */}
          <div
            key={'Total parciales'}
            className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-gray-50 to-slate-100 p-6 shadow-lg ring-1 ring-gray-200/50"
          >
            <div className="relative">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-3">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-gray-600 to-slate-700 shadow-lg">
                    <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                    </svg>
                  </div>
                  <div>
                    <dt className="text-lg font-semibold text-gray-800">Pagos Parciales</dt>
                    {/*<p className="text-sm text-gray-600">Pagos en proceso</p>*/}
                  </div>
                </div>
              </div>
              <dd className="space-y-3">
                <div className="flex items-center justify-between rounded-lg bg-white/60 p-3">
                  <span className="text-sm font-medium text-gray-600">Bolívares</span>
                  <span className="text-sm font-bold text-gray-900">Bs. {this.formatNumber(this.state.totalValues?.partialPayed?.totalXStatus?.amount)}</span>
                </div>
                <div className="flex items-center justify-between rounded-lg bg-white/60 p-3">
                  <span className="text-sm font-medium text-gray-600">Dólares</span>
                  <span className="text-sm font-bold text-gray-900">$ {this.formatNumber(this.state.totalValues?.partialPayed?.totalXStatus?.amountDolar)}</span>
                </div>
                <div className="flex items-center justify-between rounded-lg bg-white/60 p-3">
                  <span className="text-sm font-medium text-gray-600">Euros</span>
                  <span className="text-sm font-bold text-gray-900">€ {this.formatNumber(this.state.totalValues?.partialPayed?.totalXStatus?.amountEur)}</span>
                </div>
              </dd>
            </div>
          </div>


        </dl>

        {this.state.showChart ? (
          <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
            {/* Card del gráfico */}
            <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-gray-50 to-slate-100 p-6 shadow-lg ring-1 ring-gray-200/50 lg:col-span-8">
              <div className="relative">
                <div className="mb-4 flex items-center space-x-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-gray-600 to-slate-700 shadow-lg">
                    <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800">Total de multas por estado</h3>
                    <p className="text-sm text-gray-600">Distribución de multas según su estado</p>
                  </div>
                </div>
                <div className="bg-white/60 rounded-xl p-4" style={{height:'380px'}}>
                  <Bar
                    options={{
                      indexAxis: 'y',
                      responsive: true,
                      maintainAspectRatio: false,
                      plugins: {
                        legend: { 
                          position: 'top',
                          labels: {
                            usePointStyle: true,
                            padding: 20,
                            font: {
                              size: 12,
                              weight: '500'
                            }
                          }
                        },
                        title: { 
                          display: false
                        },
                      },
                    }}
                    data={{
                      labels: this.state.labels,
                      datasets: [
                        {
                          label: 'Total',
                          data: this.state.items,
                          backgroundColor:  [
                            '#6b7280',
                            '#9ca3af',
                            '#d1d5db',
                            '#e5e7eb',
                            '#f3f4f6'
                          ],
                          borderRadius: 8,
                          borderSkipped: false,
                        },
                      ],
                    }}
                    updateMode="resize"
                  />
                </div>
              </div>
            </div>

            {/* KPIs adicionales */}
            <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-gray-50 to-slate-100 p-6 shadow-lg ring-1 ring-gray-200/50 lg:col-span-4">
              <div className="relative">
                <div className="mb-6 flex items-center space-x-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-gray-600 to-slate-700 shadow-lg">
                    <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800">Resumen General</h3>
                    <p className="text-sm text-gray-600">Estadísticas detalladas</p>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="rounded-xl bg-white/60 p-4">
                    <div className="flex items-center justify-between mb-2">
                      <dt className="text-sm font-medium text-gray-600">Total Multas Impuestas</dt>
                    </div>
                    <dd className="text-2xl font-bold text-gray-900">{this.state.data?.[0]?.totalGeneral.toLocaleString('es-ES', {
    useGrouping: true,
  }) ?? 0}</dd>
                  </div>
                  <div className="rounded-xl bg-white/60 p-4">
                    <div className="flex items-center justify-between mb-2">
                      <dt className="text-sm font-medium text-gray-600">Total Multas</dt>
                    </div>
                    <dd className="text-2xl font-bold text-gray-900">{this.state.data?.[0]?.totalM.toLocaleString('es-ES', {
    useGrouping: true,
  }) ?? 0}</dd>
                  </div>
                  <div className="rounded-xl bg-white/60 p-4">
                    <div className="flex items-center justify-between mb-2">
                      <dt className="text-sm font-medium text-gray-600">Total Calco multas</dt>
                    </div>
                    <dd className="text-2xl font-bold text-gray-900">{this.state.data?.[0]?.totalCM.toLocaleString('es-ES', {
    useGrouping: true,
  }) ?? 0}</dd>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        <dl className="mt-12 mx-auto grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {this.stats.map((stat, index) => {
            return (
              <div
                key={stat.name}
                className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-gray-50 to-slate-100 p-6 shadow-lg ring-1 ring-gray-200/50"
              >
                <div className="relative">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-3">
                      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-gray-600 to-slate-700 shadow-lg">
                        <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                        </svg>
                      </div>
                      <div>
                        <dt className="text-lg font-semibold text-gray-800">{stat.name}</dt>
                        <p className="text-sm text-gray-600">{stat.change}</p>
                      </div>
                    </div>
                  </div>
                  <dd className="mb-4">
                    <div className="rounded-lg bg-white/60 p-4">
                      {this.getTotalByStat(stat.category)}
                    </div>
                  </dd>
                  <Accordion className="bg-white/40 rounded-lg">
                    <AccordionSummary 
                      aria-controls={`panel-${stat.name}-content`} 
                      id={`panel-${stat.name}-header`}
                      className="rounded-lg"
                    >
                      <div className="flex items-center space-x-2">
                        {this.renderIcon()}
                        <p className="text-gray-600 font-medium">Ver más detalles</p>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails className="pt-4">
                      <div className="bg-white/60 rounded-lg p-3">
                        {this.returnByCategory(stat.category)}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </div>
            );
          })}
        </dl>
      </div>
  )

}
}

export default Items;